import { Bell } from 'lucide-react';

export function NotificationsPage() {
  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Bell className="h-6 w-6 text-[#cc0404]" />
        <h1 className="text-2xl font-semibold">Notifications</h1>
      </div>
      <p className="text-[#767676] mb-6">View your recent notifications and alerts.</p>
      <div className="bg-white rounded-lg border border-[#E2E2EA] p-8 text-center">
        <Bell className="h-12 w-12 text-[#A39C98] mx-auto mb-4" />
        <h3 className="text-lg font-medium text-[#17171B] mb-2">No notifications</h3>
        <p className="text-sm text-[#767676]">You're all caught up! Notifications will appear here when there are updates.</p>
      </div>
    </div>
  );
}
